module.exports = __webpack_public_path__ + "static/media/PingFang-SC-Light.1acd3661.svg";